import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  toggleSigning({ detail }) {
    this.element.classList.toggle('signing', detail.signing);
  }
}
